import { render, staticRenderFns } from "./scorerecordlist.vue?vue&type=template&id=df42406e&scoped=true"
import script from "./scorerecordlist.vue?vue&type=script&lang=js"
export * from "./scorerecordlist.vue?vue&type=script&lang=js"
import style0 from "./scorerecordlist.vue?vue&type=style&index=0&id=df42406e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df42406e",
  null
  
)

export default component.exports